import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedDetailMeasurement from './helpers/PdpSharedDetailMeasurement';

// helpers
import get from 'lodash.get';

function PdpSharedDetailHip({ item }) {
    return (
        <PdpSharedDetailMeasurement
            dataTn="pdp-spec-hip"
            measurements={get(item, 'measurement.hip')}
        />
    );
}

PdpSharedDetailHip.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailHip, {
    item: graphql`
        fragment PdpSharedDetailHip_item on Item {
            measurement {
                hip: display(fields: [hip]) {
                    ...PdpSharedDetailMeasurement_measurements
                }
            }
        }
    `,
});
